import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import Specialization3 from '../Elements/Specialization3';
import OurValue3 from '../Elements/OurValue3';
import OurProject3 from '../Elements/OurProject3';

var bnrimg = require('./../../images/banner/1.jpg');

class HVAC extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Diversified services. Unvarying quality." pagename="Services" bgimage={bnrimg}/>
                    <AboutCompany />
                    <Specialization3 />
                    <OurValue3 />
                    <OurProject3 />
                    {/* <Faq /> */}
                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default HVAC;